export const staticLineHeight = 1.5;
